/**
 * Get the current auth token, preferring OIDC (Zitadel) over LS JWT.
 * Used across the app wherever an Authorization header is needed.
 */
export function getAuthToken(): string | null {
  if (typeof localStorage === "undefined") return null;

  // Check for OIDC token first (from oidc-client-ts)
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith("oidc.user:")) {
      try {
        const parsed = JSON.parse(localStorage.getItem(key) || "");
        if (parsed.access_token) return parsed.access_token;
      } catch {
        /* ignore */
      }
    }
  }

  // Fall back to Label Studio JWT token
  return localStorage.getItem("jwt_access_token");
}